import React, { useEffect, useRef, useState } from "react";
import { View, StyleSheet } from "react-native";
import { Marker } from "react-native-maps";
import Text from "@components/CustomText";
import { getInitials, getAvatarColors } from "../utils";

// Custom-view markers on Android need two workarounds to actually draw:
// 1. collapsable={false} on the child root — the view flattener otherwise
//    collapses a plain View+Text subtree and the marker rasterizes empty
//    (OrdersMapView dodges this by accident because its child has an Image).
// 2. tracksViewChanges must stay true until the first real raster, then be
//    frozen for perf (Android re-rasterizes every frame while true).
const DbMarker = ({ db, onPress }) => {
  const markerRef = useRef(null);
  const [track, setTrack] = useState(true);
  const colors = getAvatarColors(db.name || db.phone);

  useEffect(() => {
    const t = setTimeout(() => setTrack(false), 800);
    return () => clearTimeout(t);
  }, []);

  return (
    <Marker
      ref={markerRef}
      coordinate={{ latitude: Number(db.lat), longitude: Number(db.lng) }}
      anchor={{ x: 0.5, y: 0.5 }}
      tracksViewChanges={track}
      tracksInfoWindowChanges={false}
      onPress={onPress}
    >
      <View
        collapsable={false}
        style={[
          styles.avatar,
          { backgroundColor: colors.bg, borderColor: colors.fg },
        ]}
      >
        <Text style={[styles.initials, { color: colors.fg }]}>
          {getInitials(db.name)}
        </Text>
      </View>
    </Marker>
  );
};

export default DbMarker;

const styles = StyleSheet.create({
  avatar: {
    width: 22,
    height: 22,
    borderRadius: 11,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  initials: {
    fontSize: 8,
    fontWeight: "700",
  },
});
